import { createSession as createSessionMethod } from "@shapediver/viewer";

export async function createSession() {
  const urlParams = new URLSearchParams(window.location.search);
  const ticket = urlParams.get('ticket');

  if (!ticket) {
    console.error('Ticket ID not found in URL parameters.');
    return null;
  }

  return await createSessionMethod({
    ticket,
    modelViewUrl: "https://sdr7euc1.eu-central-1.shapediver.com",
    id: "mySession",
  });
}
